export const PATHS = {
  // AUTH
  auth: {
    login: '/auth/login',
    register: '/auth/register',
    forgotPassword: '/auth/forgot-password',
    newPassword: '/auth/new-password',
    confirmEmail: '/auth/confirm-email',
  },
  app: {
    dashboard: '/dashboard',
    courses: '/courses',
    feedbacks: '/feedbacks',
    singleCourse: '/courses/:courseId',
    survey: '/courses/:courseId/survey/:surveyId',
    lecture: '/courses/:courseId/lecture/:lectureId',
    students: '/students',
    studentsImport: '/students/import',
    singleStudent: '/students/:studentId',
    orgStructure: '/org-structure',
    assignments: '/assignments',
    singleAssignment: '/assignments/:assignmentId',
    categories: '/categories',
    members: '/members',
    settings: '/settings',
    profileSettings: '/settings/profile',
    platformSettings: '/settings/platform',
    platformBilling: '/settings/billing',
    analytics: '/analytics',
    analyticsProgress: '/analytics/progress',
    analyticsProgressByMembers: '/analytics/progress/members',
    analyticsProgressByContent: '/analytics/progress/content',
    analyticsPoints: '/analytics/points',
    analyticsTrainingControl: '/analytics/training-control',
    submissions: '/submissions',
    exam: '/courses/:courseId/exam/:examId',
    examCreate: '/courses/:courseId/exam/:examId/create',
    examCreateFromFileStep: '/courses/:courseId/exam/:examId/create/file/step/:step',
    examCreateFromLecturesStep: '/courses/:courseId/exam/:examId/create/lectures/step/:step',
    singleStream: '/streams/:streamId',
    singleGroup: '/groups/:groupId',
    singleMember: '/members/:memberId',
    examSubmissions: '/exam-submissions',
    singleExamSubmission: '/exam-submissions/:examId',
    practiceResults: '/practice-results',
    singlePracticeResult: '/practice-results/:lectureId',
    courseCollections: '/course-collections',
    singleCourseCollection: '/course-collections/:collectionId',
    tariffs: '/tariffs',
    auditLogs: '/audit-logs',
    paymentMethods: '/payment-methods',
    salesHistory: '/sales-history',
    chatbot: '/chatbot',
    chats: '/chats',
    singleChat: '/chats/:chatId',
    liveSessions: '/live-sessions',
    liveSessionReport: '/live-sessions/:sessionId',
    liveSessionCall: '/live-sessions/:sessionId/call',
    integrations: '/integrations',
    singleIntegration: '/integrations/:provider',
    aiAgents: '/integrations/ai-agents',
  },
  oauth: {
    consent: '/oauth/consent',
  },
  // Common
  root: '/',
};

export const getRelativePath = (parent: string, child: string) => child.slice(parent.length + 1);

export type BreadcrumbRoute = {
  current: string;
  links: {
    name: string;
    path: string;
  }[];
};

type BreadcrumbPathKeys = 'courses' | 'categories' | 'students' | 'singleStudent' | 'analytics';

export const BREADCRUMB_PATHS: Record<BreadcrumbPathKeys, BreadcrumbRoute> = {
  //  This is the example. Feel free to add more routes or edit existing ones
  courses: {
    links: [],
    current: 'courses',
  },
  categories: {
    links: [],
    current: 'categories',
  },
  students: {
    links: [],
    current: 'students',
  },
  singleStudent: {
    links: [
      {
        name: 'students',
        path: PATHS.app.students,
      },
    ],
    current: 'single-student',
  },
  analytics: {
    links: [],
    current: 'analytics',
  },
};
